// extracted by mini-css-extract-plugin
export var createdDate = "_gj-1";
export var divider = "_gj-2";
export var headerDivider = "_gj-3";
export var messagesCard = "_gj-0";
export var messagesContainer = "_gj-6";
export var messagesContainerWrapper = "_gj-4";
export var showLeftPanelButton = "_gj-8";
export var topButtons = "_gj-7";
export var withPadding = "_gj-5";